import { Box, Button, Code, Stack, Text, Title } from "@mantine/core";
import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * App-wide error boundary. Without one, any throw during render unmounts the
 * whole React tree → a silent blank white screen (the exact symptom seen when a
 * component renders against partial post-login state). This degrades a render
 * failure into a readable fallback + a reload, and logs the real error so it can
 * be diagnosed instead of vanishing.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] render crash:", error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Box p="xl" style={{ maxWidth: 640, margin: "10vh auto" }}>
        <Stack gap="md">
          <Title order={3}>Хуудас ачаалахад алдаа гарлаа</Title>
          <Text c="dimmed" size="sm">
            Түр зуурын алдаа гарлаа. Хуудсаа дахин ачаалж үзнэ үү. Асуудал давтагдвал доорх алдааг дэмжлэгийн багт мэдэгдэнэ үү.
          </Text>
          <Code block>{error.message || String(error)}</Code>
          <Button color="brand" onClick={() => window.location.reload()} w="fit-content">
            Дахин ачаалах
          </Button>
        </Stack>
      </Box>
    );
  }
}
